export const appConfig = {
	title: 'Hub',
	baseUrl: 'remotesocial.io',
	subdomain: 'hub',
};
